//Generated File 
export default class GenerationType{
	static readonly GeneratedEditable = `GeneratedEditable`;
	static readonly GeneratedFinal = `GeneratedFinal`;
	static readonly NotGenerated = `NotGenerated`;
}
